import axios from 'axios';
import { ProductModel} from '../models/product';
import { User } from '../models/user';

interface payloadProps {
    CODE:string;
    NAME:string;
    AMOUNT: number;
    PRICE: number;
}

export async function SendOrderToLocs(recipient: string, subject: string, cartItems: ProductModel[], comments: string, loggedInUser: User) {
    const customer = loggedInUser.name + " " + loggedInUser.lastname;
    const order: payloadProps[] = cartItems
    .map(item => ({
        CODE: item.CODE,
        NAME: item.NAME,
        AMOUNT: item.AMOUNT,
        PRICE: Number(item.PRICE)
    }));

    const payload = { RECIPIENT: recipient, SUBJECT: subject, CUSTOMER: customer, ORDER: order, COMMENTS: comments };
            try {
                    const response = await axios.post( "/api/shop/sendorder", payload);
                if (response.status===200){
                    return true;
                    }
            } catch (error) {
                    console.error(error);
                    return false;
            }
};